import { render, staticRenderFns } from "./crudUnitMeasurement.vue?vue&type=template&id=53d04b45"
import script from "./crudUnitMeasurement.vue?vue&type=script&lang=js"
export * from "./crudUnitMeasurement.vue?vue&type=script&lang=js"
import style0 from "./crudUnitMeasurement.vue?vue&type=style&index=0&id=53d04b45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports